import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FolderSearch } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const FileListenerNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'File Listener'}
        icon={FolderSearch}
        colorClass="from-purple-500 to-purple-700"
        bgClass="bg-gradient-to-br from-purple-500 to-purple-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={true}
        isTarget={false}
        rowsProcessed={data?.rowsAffected}
    />
));
FileListenerNode.displayName = 'FileListenerNode';
export default FileListenerNode;
